import React from 'react';
import { Create, TabbedForm } from 'react-admin';
import PermanentPlacementFormToolbar from './PermanentPlacementFormToolbar';
import PermanentPlacementDetailsTab from './formTabs/PermanentPlacementDetailsTab';

const PermanentPlacementCreate = () => (
  <Create data-testid="permanentplacement-create" redirect="show">
    <TabbedForm
      toolbar={<PermanentPlacementFormToolbar />}
      defaultValues={{
        flexible_starts_date: true,
      }}
    >
      <TabbedForm.Tab label="Job Details">
        <PermanentPlacementDetailsTab />
      </TabbedForm.Tab>
    </TabbedForm>
  </Create>
);

export default PermanentPlacementCreate;
